import { Component, EventEmitter, NgZone, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertController, LoadingController, NavController } from '@ionic/angular';
import { BUSNQuoteScheduleService, BUSNThirdPartyService, BUSNUserService } from '@takectrl-multiapp/svcs-core-business';
import {
  IInsurersDetails,
  IQuote,
  IQuoteErrorRepsonse,
  IQuoteRequest,
  QuoteRequestStatusType,
  QuoteRequestType,
  SharedConfig,
  SharedDialogService,
} from '@takectrl-multiapp/svcs-share-config';
import { BUSNCommunicationService } from 'libs/svcs-core-business/src/lib/services/busn-communication.service';
import { SharedConfigService } from 'libs/svcs-share-config/src/lib/services/shared-config.service';
import { PageType } from 'libs/svcs-share-config/src/lib/types/page.type';
declare const dataLayer: unknown[];

@Component({
  selector: 'quote',
  standalone: false,
  templateUrl: './quote.component.html',
  styleUrls: ['./quote.component.scss'],
})
export class QuoteComponent implements OnInit, OnDestroy {
  @Output() navigateQuoteSummary: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() navigateQuoteNew: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() hideBackButton: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() navigateQuoteInfo: EventEmitter<unknown> = new EventEmitter();
  @Output() navigatePersonalDetails: EventEmitter<unknown> = new EventEmitter();
  @Output() navigateForwardToPage: EventEmitter<unknown> = new EventEmitter();
  @Output() navigateRootToToPage: EventEmitter<unknown> = new EventEmitter();

  loading = this.loadingCtrl.create();
  public up_to_number_of_quotes = this.sharedConfig.appSettings?.up_to_number_of_quotes;
  popupRestartQuote = false;
  showPopup = false;
  popupHeader: string;
  popupMessage: string;
  showQuotesTab = false;
  popupDidNotQuote = false;
  allInsurers: Array<IInsurersDetails> = [];
  failedPopup = false;
  private quoteRequestSub: Subscription;
  QuoteRequestType = QuoteRequestType;
  QuoteRequestStatusType = QuoteRequestStatusType;
  quoteRequest: IQuoteRequest;
  quoteErrorMessage: string;

  constructor(
    public userService: BUSNUserService,
    public zone: NgZone,
    public loadingCtrl: LoadingController,
    public alertController: AlertController,
    public navCtrl: NavController,
    public sharedConfig: SharedConfig,
    public busnQuoteScheduleService: BUSNQuoteScheduleService,
    public sharedDialogService: SharedDialogService,
    public sharedConfigService: SharedConfigService,
    private readonly busnThirdPartyService: BUSNThirdPartyService,
    private readonly busnCommService: BUSNCommunicationService
  ) {}

  async ngOnInit() {
    dataLayer.push({
      event: 'page_show',
      screenPath: 'quote',
      screenName: 'quote',
      userUid: SharedConfig.firebaseUserKey ? SharedConfig.firebaseUserKey : 'NaN',
    });
    if (this.sharedConfig.schedulesActive && this.sharedConfig.schedulesActive.length > 0) {
      SharedConfig.showFooterTabs = true;
    }
    this.sharedConfig.setShowCustomLoader(true);
    await this.userService.doQuoteRequestDetailsRun();
    this.sharedConfig.setShowCustomLoader(false);
    SharedConfig.selectedPage = PageType.homeQuote;
    // TODO implement this variable rather than shared conf
    this.quoteRequest = this.sharedConfig.quoteRequest;

    this.busnQuoteScheduleService.getInsurers().then((insurers) => {
      this.allInsurers = insurers.filter((x) => x.active);

      this.allInsurers.map((x) => {
        switch (x.insurer_id) {
          case 'ABSAPLUS':
            x.img_source = 'assets/images/insurer-logos/left-color-logos/absaplus-colour.svg';
            break;
          case 'ABSAPREMIUM':
            x.img_source = 'assets/images/insurer-logos/left-color-logos/absapremium-colour.svg';
            break;

          case 'BROLINK10':
            x.img_source = 'assets/images/insurer-logos/left-color-logos/brolink10-colour.svg';
            break;

          case 'BRYTE':
            x.img_source = 'assets/images/insurer-logos/left-color-logos/bryte-colour.svg';
            break;

          case 'SANTAM':
            x.img_source = 'assets/images/insurer-logos/left-color-logos/santam-colour.svg';
            break;
          case 'KINGPRICE':
            x.img_source = 'assets/images/insurer-logos/left-color-logos/kingprice-colour.svg';
            break;
          case 'MIWAY':
            x.img_source = 'assets/images/insurer-logos/left-color-logos/miway-colour.svg';
            break;

          case 'MUTUAL&FEDERAL':
            x.img_source = 'assets/images/insurer-logos/left-color-logos/mutual&federal-colour.svg';
            break;

          case 'PEERLESS':
            x.img_source = 'assets/images/insurer-logos/left-color-logos/peerless-colour.svg';
            break;

          case 'SANTAMDIRECT':
            x.img_source = 'assets/images/insurer-logos/left-color-logos/santamdirect-colour.svg';
            break;

          case 'MOMENTUMINSURE':
            x.img_source = 'assets/images/insurer-logos/left-color-logos/momentuminsure-colour.svg';
            break;
          default:
            break;
        }
      });
    });
    this.startNewQuote = this.startNewQuote.bind(this);
    this.cancel = this.cancel.bind(this);
    this.showIntercom = this.showIntercom.bind(this);

    this.quoteRequestSub = this.sharedConfigService.quoteRequest$.subscribe((quoteRequest) => {
      if (quoteRequest) {
        this.quoteRequest = quoteRequest;
        this.failedQuoteErrorMessage(quoteRequest.status);
      }
    });
  }

  ngOnDestroy() {
    this.quoteRequestSub?.unsubscribe();
  }

  navFromRefPage(page: string) {
    if (page === 'personal-details') {
      this.navigatePersonalDetails.emit();
    } else {
      this.navigateRootToToPage.emit(page);
    }
  }

  async fetchingQuotesStillInProgressMessage() {
    this.sharedDialogService.showPopupDialog({
      header: 'Fetching Quotes',
      subHeader: "Please hang tight, we're almost done fetching your quotes",
      buttonOneText: 'OK',
      buttonOneCallback: this.sharedDialogService.hidePopupDialog,
    });
  }

  showQuoteInfo() {
    this.navigateQuoteInfo.emit();
  }

  async navToMyQuote() {
    this.navigateQuoteNew.emit();
  }

  getInsurerThatReturnedQuotesList(): IInsurersDetails[] {
    const quotes = this.sharedConfig.quoteRequest.quotes;
    const insurers = SharedConfig.insurers;
    const returnInsurers: IInsurersDetails[] = [];
    for (const insurer of this.allInsurers) {
      if (insurers().find((x) => x.id === insurer.id)) {
        if (quotes && quotes.find((x) => x.insurer_id === insurer.insurer_id)) {
          returnInsurers.push(insurer);
        }
      }
    }
    return returnInsurers;
  }

  getInsurerThatHasNotReturnedQuotesList(quotes: IQuote[]): IInsurersDetails[] {
    const returnInsurers: IInsurersDetails[] = [];
    for (const insurer of this.allInsurers) {
      if (SharedConfig.insurers().find((x) => x.id === insurer.id)) {
        if (!quotes || !quotes.find((x) => x.insurer_id === insurer.insurer_id)) {
          returnInsurers.push(insurer);
        }
      }
    }
    return returnInsurers;
  }

  chatToUs() {
    this.busnCommService.openContactCardPopup();
    this.failedPopup = false;
  }

  closeQuoteFailedMessage() {
    this.failedPopup = false;
  }

  backToWalletPage() {
    this.navigateRootToToPage.emit('home/home-wallet');
  }

  async startNewQuote() {
    this.sharedConfig.setShowCustomLoader(true);
    this.sharedDialogService.hidePopupDialog();
    SharedConfig.hideHeader = false;
    this.busnThirdPartyService.logEvent('action_start_new_quote');
    try {
      this.busnQuoteScheduleService.createNewQuoteRequest().then(async (quoteReq) => {
        this.navigateQuoteNew.emit();
        this.sharedConfig.setShowCustomLoader(false);
      });
    } catch (error) {
      this.sharedDialogService.showPopupDialog({
        header: 'Something went wrong!',
        subHeader: error.message,
        buttonOneText: 'OK',
        buttonOneCallback: this.sharedDialogService.hidePopupDialog,
      });
      this.sharedConfig.setShowCustomLoader(false);
    }
  }

  async startNewQuoteVerifyDialog() {
    SharedConfig.showFooterTabs = false;
    SharedConfig.hideHeader = true;
    this.sharedDialogService.showPopupDialog({
      header: 'Are you sure you want to edit your quote?',
      subHeader:
        'We will keep the progress made on the assets you have added. Any changes made, may influence the quoted premium.',
      buttonOneText: 'Edit my quote',
      buttonOneCallback: this.startNewQuote,
      buttonTwoText: 'Close',
      buttonTwoCallback: this.cancel,
    });
  }

  async cancelQuoteRequest() {
    this.sharedConfig.setShowCustomLoader(true);
    await this.busnQuoteScheduleService.cancelQuoteRequest();
    this.sharedConfig.setShowCustomLoader(false);
  }

  openViewNewQuotesPage() {
    if (this.sharedConfig.quoteRequest.status === QuoteRequestStatusType.WaitingToAccept) {
      this.busnThirdPartyService.logEvent('action_quote_reviewed_waiting_to_accept');
    } else if (this.sharedConfig.quoteRequest.status === QuoteRequestStatusType.WaitingOnQuotes) {
      this.busnThirdPartyService.logEvent('action_quote_reviewed_waiting_on_quotes');
    }
    if (this.sharedConfig.quoteRequest.quotes && this.sharedConfig.quoteRequest.quotes.length > 1) {
      this.navigateQuoteSummary.emit();
    } else {
      this.navigateForwardToPage.emit('quote-comparison-overall');
    }
  }

  cancel = () => {
    this.sharedDialogService.hidePopupDialog();
    SharedConfig.hideHeader = false;
    if (this.sharedConfig.schedulesActive.length > 0) {
      SharedConfig.showFooterTabs = true;
    }
  };

  showPopupDidNotQuote() {
    this.sharedDialogService.showPopupDialog({
      header: 'Some insurers did not quote',
      subHeader:
        'Some of the insurers were unable to provide a quote. Please chat to us if you would like to find out more, or continue if you are happy with the quotes you have received.',
      buttonOneText: 'Ok got it',
      buttonOneCallback: this.cancel,
      buttonTwoText: 'Contact us',
      buttonTwoCallback: this.showIntercom,
    });
  }

  showIntercom = () => {
    this.sharedDialogService.hidePopupDialog();
    this.busnCommService.openContactCardPopup();
  };

  showHideDidNotQuotes() {
    if (this.showQuotesTab === false) {
      this.showQuotesTab = true;
    } else {
      this.showQuotesTab = false;
    }
  }

  async failedQuoteErrorMessage(quote_request_status: QuoteRequestStatusType): Promise<void> {
    const activeInsurerProviders = SharedConfig.insurers().filter(i => i.active).map(i => i.provider);
    const onlyPremiaActive = activeInsurerProviders.length > 0 && activeInsurerProviders.every(p => p === 'premia');
    const activePremiaInsurerIds = SharedConfig.insurers().filter(i => i.active && i.provider === 'premia').map(i => i.insurer_id);
    if (!onlyPremiaActive) return;
    if (quote_request_status === QuoteRequestStatusType.Failed) {
      let resposne = await this.busnQuoteScheduleService.getQuoteErrorMessage(this.sharedConfig.quoteRequest.id, activePremiaInsurerIds[0]);
        if (resposne.results && Object.keys(resposne.results).length === 0) {
          this.quoteErrorMessage = 'Your quote request failed, please try and run a request again.';
        } else {
          let results = resposne.results as IQuoteErrorRepsonse;
          console.error('Quote Failed Reason - ' + results?.message)
          if (results.event === 'underwriting_lock') {
            this.quoteErrorMessage = results.message;
          } else {
            this.quoteErrorMessage = 'Your quote request failed, please try and run a request again.';
          }
        }
        this.failedPopup = true;
    }
  }
}
